import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AccountAppApi } from './app'
import { AccountBackofficeApi } from './backoffice'
import { Queue } from '../../queue'

export class Account implements ApiNamespaces {
  app: AccountAppApi
  backoffice: AccountBackofficeApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AccountAppApi(name, sessionId, requestsQueue, options)
    this.backoffice = new AccountBackofficeApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
